import { render } from "./QuickpayOverview.vue?vue&type=template&id=38380ded&scoped=true"
import script from "./QuickpayOverview.vue?vue&type=script&lang=js"
export * from "./QuickpayOverview.vue?vue&type=script&lang=js"

import "./QuickpayOverview.vue?vue&type=style&index=0&id=38380ded&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38380ded"]])

export default __exports__